__turbopack_context__.v({
  "container": "index-module__ETqdJq__container",
  "inviteInput": "index-module__ETqdJq__inviteInput",
});
